import { useLocation } from "react-router-dom";
import { useHomeData } from "../../context/HomeContext";
import { urlFor } from "../../utils/imageUrl";

import "./index.css";

export const Post = () => {
  const { pathname } = useLocation();
  const pathParts = pathname.split("/");
  const postFromPathname = pathParts[pathParts.length - 1];

  const homeData = useHomeData();

  const postData =
    homeData?.posts?.find((post) =>
      post.cta.slug.current.includes(postFromPathname),
    ) || null;

  return (
    <>
      <div className="post-page">
        <section className="post-section">
          <article className="post">
            {postData ? (
              <div className="content">
                <img
                  className="media"
                  src={urlFor(postData.media.asset._ref).width(1200).url()}
                  alt={postData.heading}
                />
                <h1>{postData.heading}</h1>
                <h3>{postData.subTitle}</h3>
                <p>{postData.description}</p>
              </div>
            ) : (
              <h1> Nothing to see here... </h1>
            )}
          </article>
        </section>
      </div>
    </>
  );
};
